var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",on:{"click":_vm.archive}},[_c('div',{staticClass:"supel"},[_c('ArchiveIcon')],1),_vm._v(" "+_vm._s(_vm.chat.archived ? _vm.$t("messenger.unarchive") : _vm.$t("messenger.to_archive"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }